
import { Box, Typography } from '@mui/material'
import { GridRenderCellParams, GridTreeNodeWithRender } from '@mui/x-data-grid-pro'
import { Link } from 'react-router-dom'
import { DensityStyleTypes } from '../../../../types'

interface ContractedByCellProps {
  params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>
  densityStyles: DensityStyleTypes
}

const ContractedByCell: React.FC<ContractedByCellProps> = ({ params, densityStyles }) => {
  const contractedBy = params?.row?.contractedBy ?? []
  const contractedByPK = contractedBy?.[0]?.PK || `ORG_${contractedBy?.[0]?.org_uuid}`
  // return contractedBy && contractedBy?.org_uuid ? (
  // if (!params?.row?.isParent) return <ChildNoValueCell densityStyles={densityStyles} />
  //@ts-ignore
  if (params?.rowNode?.isAutoGenerated) return
  return contractedBy && contractedBy?.length > 0 ? (
    <Link
      to={`/organizations/${contractedByPK}/details`}
      style={{
        textDecoration: 'none',
        color: 'inherit',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'left',
          alignItems: 'center',
          height: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          padding: densityStyles.padding,
          gap: densityStyles.gap,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'left', overflow: 'hidden', textOverflow: 'ellipsis', gap: 1 }}>
          <Typography
            sx={{
              fontSize: densityStyles.fontSize,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              textAlign: 'center',
              color: params?.value ? 'text.primary' : 'text.disabled',
            }}
          >
            {params?.value ?? '—'}
          </Typography>
        </Box>
      </Box>
    </Link>
  ) : (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'left',
        alignItems: 'center',
        textAlign: 'left',
        height: '100%',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: 'text.disabled',
      }}
    >
      {'—'}
    </Box>
  )
}
export default ContractedByCell
